import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CheckCircle2, Clock3, Loader2, RotateCcw, Users, XCircle } from "lucide-react";
import {
  fetchCasinoPlayers,
  selectCasinoLoadingPlayers,
  selectCasinoPlayers,
} from "../../redux/casinoSlice";

const BondSpinStagePanel = () => {
  const dispatch = useDispatch();
  const players = useSelector(selectCasinoPlayers);
  const loadingPlayers = useSelector(selectCasinoLoadingPlayers);

  useEffect(() => {
    dispatch(fetchCasinoPlayers());
  }, [dispatch]);

  const renderPlayers = () => {
    if (loadingPlayers) {
      return (
        <div className="bplay-spin-panel-loading">
          <Loader2 size={20} className="bplay-spin" />
          <span>Loading players…</span>
        </div>
      );
    }

    if (players.length === 0) {
      return (
        <div className="bplay-spin-panel-empty">
          <Users size={24} strokeWidth={2} />
          <p>No roulette players right now</p>
          <span>Everyone playing on live Bond Spin tables will appear here.</span>
        </div>
      );
    }

    return (
      <ul className="bplay-spin-panel-list">
        {players.map((player) => (
          <li key={player.userId}>
            <div className="bplay-spin-panel-row player">
              <span className="bplay-spin-panel-row-icon">
                <Users size={15} strokeWidth={2.25} />
              </span>
              <span className="bplay-spin-panel-row-main">
                <strong>{player.username || "Anonymous"}</strong>
              </span>
              <span className="bplay-spin-panel-row-stats">
                <span className="bplay-spin-panel-stat won" title="Won">
                  <CheckCircle2 size={12} strokeWidth={2.5} />
                  {player.won || 0}
                </span>
                <span className="bplay-spin-panel-stat lost" title="Lost">
                  <XCircle size={12} strokeWidth={2.5} />
                  {player.lost || 0}
                </span>
                <span className="bplay-spin-panel-stat pending" title="Pending">
                  <Clock3 size={12} strokeWidth={2.5} />
                  {player.pending || 0}
                </span>
                <span className="bplay-spin-panel-stat refunded" title="Refunded">
                  <RotateCcw size={12} strokeWidth={2.5} />
                  {player.refunded || 0}
                </span>
              </span>
            </div>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <section className="bplay-spin-panel" aria-label="Bond Spin players">
      <div className="bplay-spin-panel-head">
        <Users size={13} strokeWidth={2.5} />
        <span>Players</span>
        <span className="bplay-spin-panel-head-count">{players.length}</span>
      </div>
      <div className="bplay-spin-panel-body">{renderPlayers()}</div>
    </section>
  );
};

export default BondSpinStagePanel;
